import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Unmatched transparency in property presentation', 'Empowers highly informed decision-making', 'Ultimate convenience for busy professionals', 'Drastically reduced physical inspection fatigue', 'Premium marketing for high-end real estate'];
export function WhyMatters() {
  return <section className="py-24 bg-zinc-950" data-id="element-256">
      <div className="max-w-7xl mx-auto px-6" data-id="element-257">
        <div className="glass-panel rounded-3xl p-8 md:p-16 bg-gradient-to-br from-white/[0.05] to-transparent" data-id="element-258">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-259">
            <FadeIn data-id="element-260">
              <h2 className="text-3xl md:text-4xl font-display font-medium text-white mb-6" data-id="element-261">
                Why Virtual Tours Matter
              </h2>
              <p className="text-zinc-400 text-lg leading-relaxed mb-8" data-id="element-262">
                In a fast-paced world, time is the ultimate luxury. Virtual
                property tours in Nigeria are no longer a novelty—they are a
                necessity for modern real estate transactions.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-263">
              <ul className="space-y-6" data-id="element-264">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-265">
                    <CheckCircle2 className="w-6 h-6 text-white shrink-0" data-id="element-266" />
                    <span className="text-zinc-300 text-lg" data-id="element-267">{benefit}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}